<template>
  <div class="project-setting-view">
    <p class="project-setting-title">
      提交设置
      <span class="small-font-size ml20 text-secondary-color">
        自定义表单提交成功后的提示内容，以及可以跳转指定链接
      </span>
    </p>
    <el-divider />
    <el-form ref="submitSettingForm" :model="submitSettingForm" :rules="settingRules" @submit.native.prevent>
      <div class="setting-item">
        <p class="label" style="width: 30%">提交后显示方式</p>
        <el-radio-group v-model="submitSettingForm.submitShowType" @change="submitShowTypeChange" v-removeAriaHidden>
          <el-radio :label="1"> 系统默认提示 </el-radio>
          <el-radio :label="2"> 自定义文案 </el-radio>
        </el-radio-group>
      </div>
      <div class="mt20">
        <el-input
          :disabled="submitSettingForm.submitShowType === 1"
          v-model="submitSettingForm.submitShowCustomPageContent"
        />
      </div>
      <div class="setting-item">
        <p class="label">
          提交后跳转地址
          <el-tooltip class="item" effect="dark" placement="top-start">
            <div slot="content">
              此属性用于指定答题完成后跳转的地址，可参考以下格式
              <br />
              1.网页地址，需填写完整url<br />示例：https://demo.com<br />
              2.小程序页面地址<br />示例：/member/pages/activity/couponActivity?id=123456789
            </div>
            <i class="el-icon-question" />
          </el-tooltip>
        </p>
        <el-switch v-model="submitSettingForm.submitJump" />
      </div>
      <el-form-item
        v-if="submitSettingForm.submitJump"
        prop="submitJumpUrl"
        :rules="[{ required: true, message: '请输入跳转地址', trigger: 'blur' }]"
      >
        <el-input v-model="submitSettingForm.submitJumpUrl" placeholder="请输入" />
      </el-form-item>
      <div class="setting-item">
        <p class="label">
          提交问卷奖励
          <el-tooltip class="item" effect="dark" placement="top-start">
            <div slot="content">
              用于关联会员营销活动，配置用户提交该问卷时发放的活动奖励，具体活动设置见iadmin营销模块
            </div>
            <i class="el-icon-question" />
          </el-tooltip>
        </p>
        <el-switch v-model="submitSettingForm.memberMarketingActivities.enable" />
      </div>

      <div class="flex-row align-center el_activity" v-if="submitSettingForm.memberMarketingActivities.enable">
        提交触发会员营销活动
        <el-form-item
          prop="memberMarketingActivities.brandCode"
          :rules="[{ required: true, message: '请选择品牌', trigger: 'change' }]"
        >
          <el-select
            style="margin: 0 6px; width: 140px"
            v-model="submitSettingForm.memberMarketingActivities.brandCode"
            class="item-config-col1"
          >
            <el-option v-for="brand in brandList" :key="brand.code" :label="brand.name" :value="brand.code">
            </el-option>
          </el-select>
        </el-form-item>
        <el-select
          style="margin: 0 6px; width: 140px"
          v-model="submitSettingForm.memberMarketingActivities.type"
          class="item-config-col1"
        >
          <el-option label="点击领取活动" value="CLICK_TO_RECEIVE_EVENT"> </el-option>
        </el-select>
        <el-form-item
          prop="memberMarketingActivities.activityId"
          :rules="[{ required: true, message: '请输入活动id', trigger: 'blur' }]"
        >
          <el-input
            @input="changeInput($event)"
            v-model="submitSettingForm.memberMarketingActivities.activityId"
            placeholder="请输入活动id"
          />
        </el-form-item>
      </div>
      <div class="submit-btn">
        <el-button type="primary" @click="saveSettingHandle"> 保存设置 </el-button>
      </div>
    </el-form>
  </div>
</template>

<script>
import mixin from './mixin'
import { getSettingRequest, saveSettingRequest, getBrandList } from '../../../api/project/setting'

export default {
  name: 'SubmitSetting',
  mixins: [mixin],
  data() {
    return {
      settingRules: {},
      submitSettingForm: {
        // 提交后显示类型
        submitShowType: 1,
        // 自定义显示内容
        submitShowCustomPageContent: '提交成功',
        submitJump: false,
        submitJumpUrl: '',
        publicResult: false,
        memberMarketingActivities: {
          enable: false,
          type: 'CLICK_TO_RECEIVE_EVENT',
          activityId: '',
          brandCode: ''
        }
      },
      brandList: []
    }
  },
  mounted() {
    this.queryUserProjectSetting()
    this.getBrandList()
  },
  destroyed() {},
  methods: {
    async getBrandList() {
      const res = await getBrandList()
      this.brandList = res.data
    },
    submitShowTypeChange(val) {
      if (val == 1) {
        this.submitSettingForm.submitShowCustomPageContent = '提交成功'
      }
    },
    uploadSubmitPromptHandle(response) {
      this.submitSettingForm.promptImgUrl = response.data
    },
    queryUserProjectSetting() {
      getSettingRequest(this.formKey).then((res) => {
        if (res.data) {
          const { submitSettingForm } = this
          this.submitSettingForm = {
            ...submitSettingForm,
            ...res.data
          }
        }
      })
    },
    saveSettingHandle() {
      this.$refs['submitSettingForm'].validate((valid) => {
        // 图片检查
        if (this.submitSettingForm.promptImg && !this.submitSettingForm.promptImgUrl) {
          this.msgError('请上传提示图片')
          return
        }
        if (valid) {
          const { submitJumpUrl, memberMarketingActivities } = this.submitSettingForm
          this.submitSettingForm.formKey = this.formKey
          const isNotWebUrl = submitJumpUrl.indexOf('http://') === -1 && submitJumpUrl.indexOf('https://') === -1
          if (isNotWebUrl) {
            this.submitSettingForm.submitJumpUrl =
              submitJumpUrl.indexOf('/') === 0 ? submitJumpUrl : '/' + submitJumpUrl
          }

          saveSettingRequest(this.submitSettingForm).then(() => {
            this.msgSuccess('保存成功')
            this.queryUserProjectSetting()
          })
        } else {
          return false
        }
      })
    },
    changeInput(value) {
      this.submitSettingForm.memberMarketingActivities.activityId = value.replace(/[^0-9]/g, '')
    }
  }
}
</script>

<style lang="scss" scoped>
@import 'settting';

.submit-prompt-img {
  width: 100%;
  height: 117px;
  background-color: #f7f7f7;
  display: flex;
  align-items: center;
  justify-items: center;
  justify-content: center;
}
.el_activity {
  padding: 10px 20px;
  border-radius: 4px;
  border: 1px solid #dcdfe6;
}
</style>
